import { GetterTree } from 'vuex'
import { WidgetState } from "@/apps/StudentExchangeProgressColumnWidget/models/store-viewmodel"
import { ILabels } from "@/apps/StudentExchangeProgressColumnWidget/models/config-viewmodel";

export default <GetterTree<WidgetState, WidgetState>>{
    getLabels(state): ILabels {
        return state.labels
    },
    getProgressLabels(state): [] {
        return state.progressLabels
    }
}
